export class AccomodationSelected {
    id: string
    description: string
    price: number // in cents
    quantity: number
    constructor(
        id: string,
        description: string,
        price: number, // in cents
        quantity: number,
    ) {
        this.id = id
        this.description = description
        this.price = price
        this.quantity = quantity
    }
}

export class Prestation {
    prestIdSource: string
    amount: number // actually its quantity in this case, not price
    constructor(
        prestIdSource: string,
        amount: number, // actually its quantity in this case, not price

    ) {
        this.prestIdSource = prestIdSource
        this.amount = amount
    }
}

export class OptionSelected {
    id: string
    description: string
    price: number // in cents
    quantity: number
    constructor(
        id: string,
        description: string,
        price: number, // in cents
        quantity: number,
    ) {
        this.id = id
        this.description = description
        this.price = price
        this.quantity = quantity
    }
}

export class GlobalSelected {
    id: string
    price: number // in cents
    description: string
    constructor(
        id: string,
        price: number, // in cents
        description: string,
    ) {
        this.id = id
        this.price = price
        this.description = description
    }
}

export class ParticipantSelected {
    options: OptionSelected[]
    constructor(
        options: OptionSelected[],
    ) {
        this.options = options
    }
}

export class Booking {
    contractId: string
    prices: {
        totalPrice: number
        totalFeePrice: number
    }
    contractStatus: string
    promo: string
    data: {
        prestations: Prestation[]
        liheId: string
    }
    packageType: string
    participantsSelected: ParticipantSelected[]
    globalSelected: { [id: string]: GlobalSelected }
    accomodationsSelected: AccomodationSelected[]
    
    constructor(
        contractId: string,
        prices: {
            totalPrice: number
            totalFeePrice: number
        },
        contractStatus: string,
        promo: string,
        data: {
            prestations: Prestation[]
            liheId: string
        },
        packageType: string,
        participantsSelected: ParticipantSelected[],
        globalSelected: { [id: string]: GlobalSelected },
        accomodationsSelected: AccomodationSelected[],
    ) {
        this.contractId = contractId
        this.prices = prices
        this.contractStatus = contractStatus
        this.promo = promo
        this.data = data
        this.packageType = packageType
        this.participantsSelected = participantsSelected
        this.globalSelected = globalSelected
        this.accomodationsSelected = accomodationsSelected
    }
}